import { makeStyles } from '@material-ui/core'
import { Style, SIZE, COLOR } from 'constants/styles'

export default makeStyles({
  title: Style.configTitle(SIZE.CONTENT_TITLE, COLOR.CONTENT_BACKGROUND),
})
